import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { CreationMode } from '@components/storage-accounts/add-storage-account-wizard/add-storage-account-wizard.constants';
import {
  e2eLocators,
  fakeSecretKey
} from '@components/storage-accounts/add-storage-account-wizard/credential-forms/credential-forms.constants';
import { S3CompatibleAdditionalOptionsComponent } from '@components/storage-accounts/add-storage-account-wizard/credential-forms/s3-compatible-additional-options/s3-compatible-additional-options.component';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { I18NextPipe } from 'angular-i18next';
import {
  CardGroupComponent,
  FormGroupComponent,
  InputComponent,
  InputLabelComponent,
  InputPasswordComponent,
  RadioComponent
} from 'mbs-ui-kit';
import { StorageType } from 'mbs-ui-shared';
import { S3CompatibleCredentialForm } from '../credential-forms.model';

@UntilDestroy()
@Component({
  selector: 'mbs-credential-form-s3-compatible',
  templateUrl: './credential-form-s3-compatible.component.html',
  styleUrls: ['../credential-forms.style.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CardGroupComponent,
    CommonModule,
    FormGroupComponent,
    I18NextPipe,
    InputComponent,
    InputLabelComponent,
    InputPasswordComponent,
    RadioComponent,
    ReactiveFormsModule,
    S3CompatibleAdditionalOptionsComponent
  ]
})
export class CredentialFormS3CompatibleComponent implements OnInit {
  @Input() form: S3CompatibleCredentialForm;
  @Input() isNativeMultipartControlShown = false;
  @Input() storageType: StorageType.S3Compatible | StorageType.Minio;
  @Input() mode: CreationMode;

  public readonly StorageType = StorageType;
  public readonly fakeSecretKey = fakeSecretKey;
  public readonly e2eLocators = e2eLocators;

  public isHttps = new FormControl(true);
  public endpoint: FormControl<string> = null;

  ngOnInit() {
    if (this.mode === CreationMode.Edit) {
      this.isHttps.setValue(!this.httpEndpoint.value, { emitEvent: false });
    }

    this.onProtocolChanged(this.isHttps.value);

    this.isHttps.valueChanges.pipe(untilDestroyed(this)).subscribe((val) => {
      this.onProtocolChanged(val);
    });
  }

  get accessKey(): FormControl<string> {
    return this.form.get('accessKey') as FormControl;
  }

  get secretKey(): FormControl<string> {
    return this.form.get('secretKey') as FormControl;
  }

  get httpEndpoint(): FormControl<string> {
    return this.form.get('httpEndpoint') as FormControl;
  }

  get httpsEndpoint(): FormControl<string> {
    return this.form.get('httpsEndpoint') as FormControl;
  }

  private onProtocolChanged(val: boolean) {
    val && this.httpEndpoint.patchValue(null, { emitEvent: false });
    !val && this.httpsEndpoint.patchValue(null, { emitEvent: false });

    if (val) {
      this.endpoint = this.httpsEndpoint;
      this.httpsEndpoint.setValidators([Validators.required]);
      this.httpEndpoint.clearValidators();
    } else {
      this.endpoint = this.httpEndpoint;
      this.httpEndpoint.setValidators([Validators.required]);
      this.httpsEndpoint.clearValidators();
    }

    this.httpEndpoint.updateValueAndValidity();
    this.httpsEndpoint.updateValueAndValidity();
  }
}
